import { Engine1Proxy, SagasProxy, RestApiProxy } from 'com-gyf-webcore-servicehub';
import GlobalHelper from '../Helpers/GlobalHelper';


let TransaccionManager = function () {
    // const agregarProceso = (x => x.Checked && x.Id > 0);
    const editarProceso = (x => (x.Id > 0 && x.Cambio));

    /**
     * 
     * @param {any} data
     * @param {any} sagasCallback
     * @param {any} viewCallback
     */
    function _guardarTransaccion(transacciones, sagasCallback, viewCallback) {
        ejecutarSagasTransaccion(transacciones, sagasCallback, viewCallback)
    }


    /**
   * 
   * @param {any} data
   * @param {any} sagasCallback
   * @param {any} viewCallback
   */
    function ejecutarSagasTransaccion(data, sagasCallback, viewCallback) {


        let localValues = agregarTransaccion(data);
        
        ejecutarSagas(localValues, 'SAGA_TRANSACCION_DIARIA', sagasCallback, viewCallback);
    }

    /**
     * 
     * @param {any} localValues
     * @param {any} saga
     * @param {any} sagasCallback
     * @param {any} viewCallback
     */
    function ejecutarSagas(localValues, saga, sagasCallback, viewCallback) {

        SagasProxy.AddSagaRequests(localValues, saga, "TARJETAS", "CONSULTASOCIOS");

        RestApiProxy.SetApiUrl();

        SagasProxy.Execute(sagasCallback, undefined, viewCallback, "CONSULTASOCIOS");
    }

    function agregarTransaccion(data) {


        const { transacciones, cuentaTarjetaId } = data;
        let TipoMovimiento, SubTipoMovimiento, Leyenda = null;
        let localValues = {
            "TRANSACCION_CONTAINER": [],
            "CuentaTarjetaId": cuentaTarjetaId
        };

        transacciones.forEach(function (transaccion, index) {

            switch (transaccion.Tipo) {
                case 1:
                    TipoMovimiento = 'C';
                    SubTipoMovimiento = transaccion.Importe.Monto >= 0 ? "C" : "A";
                    Leyenda = transaccion.Descripcion;
                    break;
                case 8:
                    TipoMovimiento = 'P';
                    SubTipoMovimiento = transaccion.Importe.Monto >= 0 ? "A" : "P";
                    Leyenda = "CASHIN";
                    break;
                case 6:
                    TipoMovimiento = 'A';
                    SubTipoMovimiento = "A";
                    Leyenda = transaccion.Descripcion;
                    break;
                default:
                    TipoMovimiento = 'O';
                    SubTipoMovimiento = "O";
                    Leyenda = transaccion.Descripcion;
            }
            // ADT1758 
            // DebitoCredito = 1 Credito / Positivo Ej Cash ins : 0 Debito / Negativo Ej Cash outs
            // Importe = Se debe invertir el valor ya que GP lo envia como si se tratase de una tarjeta de credito.
            // Al invertir el importe en el guardado de la informacion de GP, no realizaremos mas conversiones en SPs

            let Transaccion = {
                "CuentaTarjetaId": cuentaTarjetaId,
                "TipoMovimiento": TipoMovimiento,
                "SubTipoMovimiento": SubTipoMovimiento,
                "Origen": "W",
                "Importe": (-1*(transaccion.Importe.Monto)),
                "ImporteImpuestos": 0,
                "DebitoCredito": transaccion.Importe.Monto >= 0 ? 0 : 1,
                "FechaOperacion": transaccion.Fecha,
                "FechaProcesoAdintar": GlobalHelper.DateBD(),
                "Leyenda": Leyenda,
                "TransaccionDiariaEstadoId": 1,
                "AutorizacionNumero": null,
                "NroComprobante": transaccion.Id
            }


            localValues.TRANSACCION_CONTAINER.push(Transaccion);
        });

        return localValues;
    }




    return {
        GuardarTransaccion: function (data, sagasCallback, viewCallback) {
            return _guardarTransaccion(data, sagasCallback, viewCallback);
        },

    }
};
let transaccionManager = new TransaccionManager();
export default transaccionManager;